import { sysadminService, type AsesoriaSysadminDTO, type AsesoriasSysadminFilter } from '@/services/sysadmin.service';
import { useCallback, useEffect, useState } from 'react';

export function useAsesoriasSysadmin(filtros?: AsesoriasSysadminFilter) {
  const [data, setData] = useState<{ asesorias: AsesoriaSysadminDTO[] } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchAsesorias = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await sysadminService.listarAsesorias(filtros);
      setData({ asesorias: res.asesorias });
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Error al cargar asesorías'));
    } finally {
      setIsLoading(false);
    }
  }, [filtros?.empresaId, filtros?.asesorId, filtros?.estado]);

  useEffect(() => {
    fetchAsesorias();
  }, [fetchAsesorias]);

  return { data, isLoading, error, refetch: fetchAsesorias };
}
